import { FC } from 'react';
import { AllAccessLocationFilterSelector } from '@frontend/analytics-shared';
import { trackingIds } from '../../../../../tracking-ids';
import { FilterIcon } from '../../atoms/filter-icon';
import { useLocationFilterData } from './use-location-filter-data';

interface LocationFilterChipProps {
  disabled?: boolean;
  trackingId?: string;
}

export const LocationFilterChip: FC<LocationFilterChipProps> = ({ disabled, trackingId }) => {
  const { defaultLocations, isLoading, isMultiLocation, locations, selectedLocations, onChange } =
    useLocationFilterData();

  if (!isMultiLocation) {
    return null;
  }

  return (
    <div data-testid='location-filter-chip'>
      <AllAccessLocationFilterSelector
        locations={locations}
        value={selectedLocations}
        defaultValue={defaultLocations}
        disabled={disabled || isLoading}
        onChange={onChange}
        trackingId={trackingId || trackingIds.callIntel.locationsFilter}
        renderIcon={(isActive) => <FilterIcon name='location-small' isFilterActive={isActive} />}
      />
    </div>
  );
};
